@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<div class="surface" [class.align-right]="attributes.rightAligned" [attr.color-variant]="attributes.bgColor === 'beige' ? 'secondary' : null">
  @if (attributes.image) {
    <kb-picture
      [picture]="imageToPicture(attributes.image.attributes, aspectRatio).sources"
      [alt]="attributes.image.attributes.alt"
      [appEditorId]="attributes.image.editorIds?.src"
      [rootColumns]="4"
    ></kb-picture>
  }
  <div class="text">
    <kb-icon class="background-logo" [icon]="backgroundLogo" icon-uppercase icon-center></kb-icon>

    @if (!attributes.hideQuotes) {
      <q [appEditorId]="editorIds?.quote">{{attributes.quote}}</q>
    } @else {
      <div [appEditorId]="editorIds?.quote">{{attributes.quote}}</div>
    }
    @if (attributes.person) {
      <p kb-paragraph class="person" [appEditorId]="editorIds?.person">
        {{attributes.person}}
      </p>
    }
  </div>
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
